import { useEffect, useRef, useState } from 'react'
import Icon from '../../components/icons.jsx'

export default function DealActionsMenu({ onArchive, onDelete }) {
  const [open, setOpen] = useState(false)
  const root = useRef(null)
  const trigger = useRef(null)
  useEffect(() => {
    if (!open) return
    const outside = (event) => { if (!root.current?.contains(event.target)) setOpen(false) }
    document.addEventListener('pointerdown', outside)
    return () => document.removeEventListener('pointerdown', outside)
  }, [open])
  const choose = (action) => { setOpen(false); action() }
  return <div className="dp-actions" ref={root} onKeyDown={(event) => { if (open && event.key === 'Escape') { event.stopPropagation(); setOpen(false); trigger.current?.focus() } }}>
    <button type="button" ref={trigger} aria-label="Mais opções do negócio" aria-expanded={open} onClick={() => setOpen(!open)}><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="5" cy="12" r="1.7" /><circle cx="12" cy="12" r="1.7" /><circle cx="19" cy="12" r="1.7" /></svg></button>
    {open && <div className="dp-actions-menu">
      <button type="button" onClick={() => choose(onArchive)}><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><rect x="3" y="3" width="18" height="5" rx="1" /><path d="M5 8v13h14V8M9 12h6" /></svg>Arquivar negócio</button>
      <button type="button" className="is-danger" onClick={() => choose(onDelete)}><Icon n="trash" s={15} />Excluir negócio</button>
    </div>}
  </div>
}
